import React, { useState } from "react";
import { Star, Phone, Mail, MapPin, Award, Clock, Shield, Car, Users, Calendar, MessageCircle } from "lucide-react";
import styles from "./Drivers.module.css";

const drivers = [
  {
    id: 1,
    name: "Fady",
    phone: "+20 110 462 5154",
    whatsapp: "+20 127 494 8282",
    image: "👨‍💼",
    experience: "8 years",
    languages: ["Arabic", "English"],
    
    // rating: 4.9,
    // totalTrips: 1250,
    carModel: "Toyota Camry 2023",
    carImages: [ 
        "/cars/car1.jpeg",
        "/cars/car2.jpg",
        "/cars/car3.jpg",
        "/cars/car4.jpg",
      ],
    availability: "Available",
    certifications: ["Licensed Professional Driver", "First Aid Certified", "Tourism Guide License"],
    description: "Fady is our most experienced driver with extensive knowledge of Egypt's historical sites. He's passionate about sharing Egyptian culture and ensuring comfortable journeys."
  },
  {
    id: 2,
    name: "Fady 2",
    phone: "+20 110 462 51543",
    whatsapp: "+20 127 494 8282",
    image: "👨‍💼",
    experience: "8 years",
    languages: ["Arabic", "English"],
    
    // rating: 4.8,
    // totalTrips: 980,
    carModel: "",
    carImages: [  
        "/cars/car21.jpg",
        "/cars/car22.jpg",
        "/cars/car23.jpg",
        "/cars/car24.jpg",
        "/cars/car25.jpg",
        "/cars/car26.jpg",
        "/cars/car27.jpg",
        "/cars/car28.jpg",
        "/cars/car29.jpg",
      ],  
    availability: "Available",
    certifications: ["Licensed Professional Driver", "Defensive Driving Certified", "VIP Service Training"],
    description: "Fady specializes in business travel and airport transfers. Known for his punctuality and discretion, he's the preferred choice for corporate clients."
  },
];

export default function Drivers() {
  const [selectedDriver, setSelectedDriver] = useState(null);


  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (img) => {
  setSelectedImage(img);
  };

  const closeImageModal = () => {
  setSelectedImage(null);
  };


  const openDriverModal = (driver) => {
    setSelectedDriver(driver);
    document.body.style.overflow = 'hidden';
  };

  const closeDriverModal = () => {
    setSelectedDriver(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.headerContent}>
          <h1 className={styles.title}>Our Professional Drivers</h1>
          <p className={styles.subtitle}>
            Meet our experienced team of licensed professionals who are dedicated to making your journey safe, comfortable, and memorable.
          </p>
        </div>
      </div>

             {/* Filter Section */}
       <div className={styles.filterSection}>
         <div className={styles.filterContainer}>
           <h3 className={styles.filterTitle}>Our Drivers</h3>
           <div className={styles.filterButtons}>
             <button 
               className={`${styles.filterButton} ${styles.active}`}
             >
               All Drivers
             </button>
           </div>
         </div>
       </div>

      {/* Drivers Grid */}
      <div className={styles.driversGridContainer}>
        <div className={styles.driversGrid}>
                     {drivers.map((driver) => (
          <div key={driver.id} className={styles.driverCard}>
            <div className={styles.cardHeader}>
              <div className={styles.driverAvatar}>
                <span className={styles.avatarEmoji}>{driver.image}</span>
                <div className={styles.availabilityBadge}>
                  <div className={styles.statusDot}></div>
                  {driver.availability}
                </div>
              </div>
              <div className={styles.driverInfo}>
                <h3 className={styles.driverName}>{driver.name}</h3>
              </div>

            </div>

            <div className={styles.cardBody}>
              <div className={styles.stats}>
                <div className={styles.stat}>
                  <Award className={styles.statIcon} />
                  <span>{driver.experience}</span>
                </div>
                <div className={styles.stat}>
                  <Car className={styles.statIcon} />
                  <span>{driver.carModel}</span>
                </div>
                <div className={styles.stat}>
                  <Users className={styles.statIcon} />
                  <span>{driver.languages.length} languages</span>
                </div>
              </div>

              <p className={styles.description}>
                {driver.description.substring(0, 120)}...
              </p>

              <div className={styles.languages}>
                {driver.languages.map((lang, index) => (
                  <span key={index} className={styles.languageTag}>
                    {lang}
                  </span>
                ))}
              </div>
            </div>

            <div className={styles.cardFooter}>
              <button 
                className={styles.viewDetailsBtn}
                onClick={() => openDriverModal(driver)}
              >
                View Full Profile
              </button>
              <div className={styles.contactButtons}>
                <a href={`tel:${driver.phone}`} className={styles.contactBtn}>
                  <Phone className={styles.contactIcon} />
                </a>
                <a href={`https://wa.me/${driver.whatsapp.replace(/\s/g, '')}`} className={styles.contactBtn} target="_blank" rel="noopener noreferrer">
                  <MessageCircle className={styles.contactIcon} />
                </a>
              </div>
            </div>
          </div>
        ))}
        </div>
      </div>


       
      {selectedImage && (
        <div className={styles.imageModalOverlay} onClick={closeImageModal}>
          <div className={styles.imageModal} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeBtn} onClick={closeImageModal}>×</button>
            <img src={selectedImage} alt="Full size" className={styles.fullImage} />
          </div>
        </div>
      )}

      {/* Driver Detail Modal */}
      {selectedDriver && (
        <div className={styles.modalOverlay} onClick={closeDriverModal}>
          <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button className={styles.closeBtn} onClick={closeDriverModal}>×</button>
            
            <div className={styles.modalHeader}>
              <div className={styles.modalAvatar}>
                <span className={styles.modalAvatarEmoji}>{selectedDriver.image}</span>
              </div>
              <div className={styles.modalInfo}>
                 <h2 className={styles.modalName}>{selectedDriver.name}</h2>
              </div>

            </div>

            <div className={styles.modalBody}>
              <div className={styles.modalSection}>
                <h3 className={styles.sectionTitle}>About {selectedDriver.name}</h3>
                <p className={styles.fullDescription}>{selectedDriver.description}</p>
              </div>

              <div className={styles.modalSection}>
                <h3 className={styles.sectionTitle}>Professional Details</h3>
                <div className={styles.detailsGrid}>
                  <div className={styles.detail}>
                    <Award className={styles.detailIcon} />
                    <div>
                      <strong>Experience:</strong> {selectedDriver.experience}
                    </div>
                  </div>
                  <div className={styles.detail}>
                    <Car className={styles.detailIcon} />
                    <div>
                      <strong>Vehicle:</strong> {selectedDriver.carModel}
                    </div>
                  </div>
                  <div className={styles.detail}>
                    <Users className={styles.detailIcon} />
                    <div>
                      <strong>Languages:</strong> {selectedDriver.languages.join(', ')}
                    </div>
                  </div>
                  <div className={styles.detail}>
                    <Shield className={styles.detailIcon} />
                    <div>
                      <strong>Status:</strong> {selectedDriver.availability}
                    </div>
                  </div>
                </div>
              </div>



              <div className={styles.modalSection}>
  <h3 className={styles.sectionTitle}>Vehicle Gallery</h3>
  <div className={styles.gallery}>
    {selectedDriver.carImages.map((img, index) => (
      <img 
        key={index} 
        src={img} 
        alt={`${selectedDriver.carModel} ${index + 1}`} 
        className={styles.galleryImage} 
        onClick={() => openImageModal(img)}
      />
    ))}
  </div>
</div>



              <div className={styles.modalFooter}>
                <div className={styles.contactInfo}>
                  <div className={styles.contactDetail}>
                    <Phone className={styles.contactDetailIcon} />
                    <span>{selectedDriver.phone}</span>
                  </div>
                  <div className={styles.contactDetail}>
                    <Mail className={styles.contactDetailIcon} />
                    <span>WhatsApp: {selectedDriver.whatsapp}</span>
                  </div>
                </div>
                <div className={styles.modalActions}>
                  <a 
                    href={`tel:${selectedDriver.phone}`} 
                    className={styles.primaryAction}
                  >
                    <Phone className={styles.actionIcon} />
                    Call Now
                  </a>
                  <a 
                    href={`https://wa.me/${selectedDriver.whatsapp.replace(/\s/g, '')}?text=Hi ${selectedDriver.name}, I'm interested in booking a tour with you.`} 
                    className={styles.secondaryAction}
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    <Mail className={styles.actionIcon} />
                    WhatsApp
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>


  );
}